import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import {
  ImportWizardRoute,
  ImportWizardPathName,
} from '@/modules/ta/importwizard/importwizard.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: `/${ImportWizardRoute.IMPORTWIZARD}`,
      name: ImportWizardPathName.IMPORTWIZARD,
      component: () =>
        import(
          /* webpackChunkName: "importwizards-page" */ '@/modules/ta/importwizard/pages/ImportWizardsPage.vue'
        ),
    },
    {
      path: `/${ImportWizardRoute.IMPORTWIZARD}/new`,
      name: ImportWizardPathName.IMPORTWIZARDFORM_NEW,
      component: () =>
        import(
          /* webpackChunkName: "importwizard-form-page" */ '@/modules/legacy/importwizard/pages/ImportWizardFormPage.vue'
        ),
      props: true,
    },
    {
      path: `/${ImportWizardRoute.IMPORTWIZARD}/detail/:id?`,
      name: ImportWizardPathName.IMPORTWIZARDFORM,
      component: () =>
        import(
          /* webpackChunkName: "importwizard-form-page" */ '@/modules/legacy/importwizard/pages/ImportWizardFormPage.vue'
        ),
      props: true,
    },
    {
      path: `/${ImportWizardRoute.IMPORTWIZARD}/clone/:id`,
      name: ImportWizardPathName.IMPORTWIZARDFORM_CLONE,
      component: () =>
        import(
          /* webpackChunkName: "importwizard-form-page" */ '@/modules/legacy/importwizard/pages/ImportWizardFormPage.vue'
        ),
      props: true,
    },
    {
      path: `/${ImportWizardRoute.IMPORTWIZARD}/detail/:parent_id/sub/:id`,
      name: ImportWizardPathName.IMPORTWIZARDFORM_SUB,
      component: () =>
        import(
          /* webpackChunkName: "importwizard-form-page" */ '@/modules/legacy/importwizard/pages/ImportWizardFormPage.vue'
        ),
      props: true,
    },
    {
      path: `/${ImportWizardRoute.IMPORTWIZARD}/manageuploads/:id`,
      name: ImportWizardPathName.IMPORTWIZARDMANAGEUPLOADS,
      component: () =>
        import(
          /* webpackChunkName: "importwizard-delete-data-page" */ './pages/ImportWizardManageUploadedFilesPage.vue'
        ),
      props: true,
    },
    {
      path: `/${ImportWizardRoute.IMPORTWIZARD}/:id/emails`,
      name: ImportWizardPathName.IMPORTWIZARD_EMAILS,
      component: () =>
        import(
          /* webpackChunkName: "importwizard-emails-page" */ './pages/ImportWizardEmailsPage.vue'
        ),
      props: true,
    },
  ],
  Module.IMPORTWIZARD
);
